var scope_0 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/154c480513174756aba5e905a91c9546.js').default;
var scope_1 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d2e63ae028bbc7824bb933068e758d0.js').default;
var scope_2 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5196d44126ff2c5231396eef1b7427a4.js').default;
var scope_3 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7388ad89e3a8c1b64f1fe5f8b2ca6754.js').default;
var scope_4 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/876ee30ef702e2042eb0ef77cdd9c781.js').default;
var scope_5 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/974edb6fc7aee68929a32d68756ba104.js').default;
var scope_6 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cb0aedd395deccdecbad13f43c316f4c.js').default;
var scope_7 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dde80e6a87164c0aa706b58d935e8309.js').default;
var scope_8 = require('/Users/ryotakewa/work/github/aventures.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    